import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AlertModel } from './../../models/alert.model';

@Component({
	selector: 'jsg-notification-bar',
	templateUrl: './notification-bar.component.html',
	styleUrls: ['./notification-bar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [trigger('fade', [transition('void => *', [style({ opacity: 0 }), animate(1000, style({ opacity: 1 }))])])],
})
export class NotificationBarComponent {
	@Input() bullets = false;
	@Input() caption = 'There were problems with the following fields. You must resolve them in order to proceed.';
	@Input() alerts: AlertModel[] = [];
}
